import './App.css';
import {Switch, Route, Link} from 'react-router-dom';
import {Layout, Typography, Space} from 'antd';
import Navbar from './components/Navbar';
import Cryptocurrencies from './components/Cryptocurrencies';
import CryptoDetails from './components/CryptoDetails';
import News from './components/News';
import Homepage from './components/Homepage';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Footer from './components/Footer';
import { green, purple } from '@mui/material/colors';

const theme = createTheme({
  palette: {
    primary: {
      main: purple[500],
    },
    secondary: {
      main: green[500],
    },
  },
});
const App = () => {


  return (
    <ThemeProvider theme={theme}>
    <div className="app">

      <div className="navbar">
        <Navbar />
      </div>

      <div className="main">
        <Layout>
          <div className="routes">
            <Switch>
              <Route exact path="/">
                  <Homepage/>
              </Route>
              <Route exact path="/cryptocurrencies">
                  <Cryptocurrencies/>
              </Route>
              <Route exact path="/coin/:coinId">
                  <CryptoDetails/>
              </Route>
              <Route exact path="/news">
                  <News/>
              </Route>
            </Switch>
          </div>
        </Layout>


        {/* <Footer/> */}
      </div>
    </div>
    </ThemeProvider>
  );
}

export default App;
